/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */

// Rubix compute
import Rubix1 from "../assets/images/RubixCompute/RubixCompute01.png";
import Rubix2 from "../assets/images/RubixCompute/RubixCompute02.png";
import Rubix3 from "../assets/images/RubixCompute/RubixCompute03.png";

// Rubix IO 16
import RubixIO1 from "../assets/images/RubixIO16/Rubix1601.png";
import RubixIO2 from "../assets/images/RubixIO16/Rubix1602.png";
import RubixIO3 from "../assets/images/RubixIO16/Rubix1603.png";

// Niagara Edge
import Edge1 from "../assets/images/NiagaraEdge/CI-EDGE.png";

// Lora Droplet
import Droplet1 from "../assets/images/LoraDroplet/Droplet01.png";
import Droplet2 from "../assets/images/LoraDroplet/Droplet02.png";
import Droplet3 from "../assets/images/LoraDroplet/Droplet03.png";

// Lora Microedge
import Micro1 from "../assets/images/MicroEdge/MicroEdge01.png";
import Micro2 from "../assets/images/MicroEdge/MicroEdge02.png";
import Micro3 from "../assets/images/MicroEdge/MicroEdge03.png";

// Icons Software Benefits
import Unified from "../assets/images/IconsBenefitsSoftware/UnifiedPlatform.svg";
import UnifiedDark from "../assets/images/IconsBenefitsSoftware/UnifiedDark.svg";
import Open from "../assets/images/IconsBenefitsSoftware/OpenProtocol.svg";
import OpenDark from "../assets/images/IconsBenefitsSoftware/OpenDark.svg";
import Flexible from "../assets/images/IconsBenefitsSoftware/FlexibleScalable.svg";
import FlexibleDark from "../assets/images/IconsBenefitsSoftware/FlexibleDark.svg";
import Real from "../assets/images/IconsBenefitsSoftware/Monitoring.svg";
import RealDark from "../assets/images/IconsBenefitsSoftware/RealDark.svg";

// Gif Benefits
import Anywhere from "../assets/Video/Node01.mp4";
import AnywhereDark from "../assets/Video/Node01dark.mp4";
import Merge from "../assets/Video/Node03.mp4";
import MergeDark from "../assets/Video/Node03dark.mp4";
import Manage from "../assets/Video/Node04.mp4";
import ManageDark from "../assets/Video/Node04dark.mp4";
import RubixWire1 from "../assets/Video/Node02.mp4";
import RubixWire1Dark from "../assets/Video/Node02dark.mp4";

// Rubix Lw
import RubixConnect from "../assets/images/RubixLW/RubixConnect01.png";
import RubixConnect2 from "../assets/images/RubixLW/RubixConnect02.png";
import RubixConnect3 from "../assets/images/RubixLW/RubixConnect03.png";

// Case Blog
import Img1 from "../assets/images/ImgFooter/RubixCompute.svg";
import Img2 from "../assets/images/ImgFooter/RubixiO16.svg";
import Img3 from "../assets/images/ImgFooter/Droplet.svg";
import Img4 from "../assets/images/ImgFooter/RubixConnect.svg";

// App Icons
import Icon1 from "../assets/images/IconsConnectivity/App1.svg";
import Icon2 from "../assets/images/IconsConnectivity/App2.svg";
import Icon3 from "../assets/images/IconsConnectivity/App3.svg";
import Icon4 from "../assets/images/IconsConnectivity/App4.svg";
import Icon5 from "../assets/images/IconsConnectivity/App5.svg";
import Icon6 from "../assets/images/IconsConnectivity/App6.svg";

// Case Study
import Galvin from "../assets/images/CaseStudy/CaseGalving.png";
import Enviro from "../assets/images/CaseStudy/CaseEnviro.png";
import Daikin from "../assets/images/CaseStudy/CaseDaikin.png";
import Victorian from "../assets/images/CaseStudy/CaseVictorian.png";
import Fujitsu from "../assets/images/CaseStudy/CaseFujitsu.png";
import Mc from "../assets/images/CaseStudy/CaseMcDonal.png";

export const RubixCompute = [
  {
    id: "1",
    image: Rubix1,
  },
  {
    id: "2",
    image: Rubix2,
  },
  {
    id: "3",
    image: Rubix3,
  },
];

export const RubixIO16 = [
  {
    id: "1",
    image: RubixIO1,
  },
  {
    id: "2",
    image: RubixIO2,
  },
  {
    id: "3",
    image: RubixIO3,
  },
];

export const Edge = [
  {
    id: "1",
    image: Edge1,
  },
];

export const Droplet = [
  {
    id: "1",
    image: Droplet1,
  },
  {
    id: "2",
    image: Droplet2,
  },
  {
    id: "3",
    image: Droplet3,
  },
];

export const Microedge = [
  {
    id: "1",
    image: Micro1,
  },
  {
    id: "2",
    image: Micro2,
  },
  {
    id: "3",
    image: Micro3,
  },
];

export const IconsBenefits = [
  {
    id: "1",
    title: "Intuitive Visual Programming",
    description:
      "Drag-and-drop logic builder designed for fast, clear setup — no traditional coding required, making complex control easier than ever.",
    icon: Unified,
    iconDark: UnifiedDark,
  },
  {
    id: "2",
    title: "Real-Time Data Control",
    description:
      "Edit and deploy live logic while monitoring real-time device feedback — test, refine, and adjust without disrupting your building operations.",
    icon: Real,
    iconDark: RealDark,
  },
  {
    id: "3",
    title: "Scalable Across Sites",
    description:
      "Easily manage one or hundreds of buildings from one central login — designed to scale across portfolios, projects, or multi-site deployments.",
    icon: Flexible,
    iconDark: FlexibleDark,
  },
  {
    id: "4",
    title: "Built for Integration",
    description:
      "Compatible with BACnet, Modbus, and LoRaWAN® protocols — connect your devices and systems into one smart automation workflow.",
    icon: Open,
    iconDark: OpenDark,
  },
];

export const GifBenefits = [
  {
    id: "1",
    image: Anywhere,
    imageDark: AnywhereDark,
  },
  {
    id: "2",
    image: Merge,
    imageDark: MergeDark,
  },
  {
    id: "3",
    image: Manage,
    imageDark: ManageDark,
  },
  {
    id: "4",
    image: RubixWire1,
    imageDark: RubixWire1Dark,
  },
];

export const RubixConnectLW = [
  {
    id: "1",
    image: RubixConnect,
  },
  {
    id: "2",
    image: RubixConnect2,
  },
  {
    id: "3",
    image: RubixConnect3,
  },
];

export const Blog1 = [
  {
    img: Img3,
    title: "LoRa® Sensors",
    link: "/lorasensors/",
  },
  {
    img: Img2,
    title: "I/O Modules",
    link: "/io-modules/",
  },
  {
    img: Img4,
    title: "Expansion Modules",
    link: "/expansionmodules/",
  },
];

export const Blog2 = [
  {
    img: Img1,
    title: "Controllers",
    link: "/controllers/",
  },
  {
    img: Img3,
    title: "LoRa® Sensors",
    link: "/lorasensors/",
  },
  {
    img: Img4,
    title: "Expansion Modules",
    link: "/expansionmodules/",
  },
];

export const Blog3 = [
  {
    img: Img1,
    title: "Controllers",
    link: "/controllers/",
  },
  {
    img: Img2,
    title: "I/O Modules",
    link: "/io-modules/",
  },
  {
    img: Img4,
    title: "Expansion Modules",
    link: "/expansionmodules/",
  },
];

export const Blog4 = [
  {
    img: Img1,
    title: "Controllers",
    link: "/controllers/",
  },
  {
    img: Img2,
    title: "I/O Modules",
    link: "/io-modules/",
  },
  {
    img: Img3,
    title: "LoRa® Sensors",
    link: "/lorasensors/",
  },
];

export const AppConect = [
  {
    id: 1,
    icon: Icon1,
    description:
      "Log into multiple buildings across a large geographical area from one",
  },
  {
    id: 2,
    icon: Icon2,
    description:
      "Access your data on your phone, laptop or tablet with no software",
  },
  {
    id: 3,
    icon: Icon3,
    description: "Fully customisable with multiple skin designs",
  },
  {
    id: 4,
    icon: Icon4,
    description: "Analyse data using a highly visual dashboard",
  },
  {
    id: 5,
    icon: Icon5,
    description:
      "Stay on top of the BMS performance with daily updates and alerts",
  },
  {
    id: 6,
    icon: Icon6,
    description: "Scheduling & trending",
  },
];

export const Casestudy = [
  {
    id: "Galvin",
    title: "Galvin Engineering",
    imageUrl: Galvin,
    type: "Enhanced patient safety & operational reliability in critical healthcare environments.",
    animation: "left",
    link: "/galvin/",
    approved: true,
  },
  {
    id: "Enviro",
    title: "Enviro Building Services",
    imageUrl: Enviro,
    type: "Reinforced their position as a leader in sustainable building management.",
    animation: "right",
    link: "/enviro/",
    approved: true,
  },
  {
    id: "Daiken",
    title: "Daikin",
    imageUrl: Daikin,
    type: "Enhanced system response times to boost customer satisfaction.",
    animation: "right",
    link: "/daikin/",
    approved: false,
  },
  {
    id: "QA Electrical",
    title: "QA Electrical",
    imageUrl: Victorian,
    type: " Energy savings support long-term sustainability goals & healthier learning spaces across 30+ Victorian schools. ",
    animation: "left",
    link: "/victorian/",
    approved: true,
  },
  {
    id: "Fujitsu",
    title: "Fujitsu anywAiR® iO",
    imageUrl: Fujitsu,
    type: "Fujitsu partners with Nube iO to deliver smart building solutions.",
    animation: "right",
    link: "/fujitsu/",
    approved: false,
  },
  {
    id: "Mcdonalds AnywAIR iO",
    title: "Fujitsu anywAiR® iO",
    imageUrl: Mc,
    type: "Fujitsu anywAiR® iO solution powers smarter operations at McDonald’s Burwood.",
    animation: "right",
    link: "/mcdonalds/",
    approved: false,
  },
];
